import BaseService from "@/services/BaseService";

export default class DeviceService extends BaseService{

    constructor() {
        super();
    }

    async getDevice(devEUI) {
        const response = await fetch(this.apiBaseUrl + "/dev_eui/" + devEUI);
        return response.status == 200 ? await response.json() : null;
    }

    async fetchDevices() {
        const response = await fetch(this.apiBaseUrl + "/devices");
        return await response.json();
    }

}